import './EditBox.scss';
import classNames from 'classnames';
import { EditOutlined } from '@ant-design/icons';
import { ProcessingIcon } from './general';
import { When } from 'react-if';
import React, { useCallback, useState } from 'react';
export const EditBox = ({ children, className, editIcon, isEmpty, isReadOnly, isSalesforce, isSpreadsheet, onClick, onBlur, readOnlyHover, selectionRef, state }) => {
    var _a, _b, _c;
    const [isEditing, setIsEditing] = useState(false);
    const componentClassNames = classNames('edit-box', className, {
        editing: isEditing,
        empty: isEmpty,
        'processing-error': ((_a = state === null || state === void 0 ? void 0 : state.result) === null || _a === void 0 ? void 0 : _a.success) === false,
        readonly: isReadOnly,
        'readonly-hover': readOnlyHover,
        spreadsheet: isSpreadsheet,
        'validation-error': Boolean((_b = state === null || state === void 0 ? void 0 : state.result) === null || _b === void 0 ? void 0 : _b.message)
    });
    const handleOnClick = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        if (isReadOnly) {
            return;
        }
        setIsEditing(true);
        if (onClick) {
            onClick();
        }
        if (selectionRef === null || selectionRef === void 0 ? void 0 : selectionRef.current) {
            setTimeout(selectionRef.current.focus);
        }
    }, [isReadOnly, onClick, selectionRef]);
    const handleOnBlur = useCallback(() => {
        if (onBlur) {
            onBlur();
        }
        if (selectionRef === null || selectionRef === void 0 ? void 0 : selectionRef.current) {
            setTimeout(selectionRef.current.blur);
        }
        setIsEditing(false);
    }, [onBlur, selectionRef]);
    const showEditIcon = editIcon && !isReadOnly && !isEmpty && !isEditing && !(state === null || state === void 0 ? void 0 : state.isProcessing);
    return (React.createElement("div", { className: componentClassNames, onBlur: handleOnBlur, onClick: handleOnClick },
        React.createElement("div", { className: 'content' },
            children,
            React.createElement("div", { className: 'activity-indicators' },
                React.createElement(When, { condition: showEditIcon },
                    React.createElement(EditOutlined, { className: 'edit-icon' })),
                React.createElement(When, { condition: Boolean((state === null || state === void 0 ? void 0 : state.isProcessing) || (state === null || state === void 0 ? void 0 : state.result)) },
                    React.createElement(ProcessingIcon, { isProcessing: (_c = state === null || state === void 0 ? void 0 : state.isProcessing) !== null && _c !== void 0 ? _c : false, isSalesforce: isSalesforce, result: state === null || state === void 0 ? void 0 : state.result }))))));
};
